var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('div',{staticClass:"order-confirmation-page"},[_c('cmg-order-confirmation',{attrs:{"order":_vm.order,"delivery-info":_vm.deliveryInfo}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }